<template>
  <NuxtLayout>
    <NuxtPwaManifest />
    <NuxtPage />
    <div class="slick-list-target z-index-top position-absolute" />
    <reusable-notification v-if="notificationConfig" v-model="notificationShown" :config="notificationConfig" />
    <reusable-prompt v-for="prompt in promptQueue" :key="prompt.id" v-bind="prompt" />
  </NuxtLayout>
</template>

<script lang="ts" setup>
useSecurityStore()
useSettingsStore()
useDashboardsStore()
useLinkedDashboardsStore()
useDevicesStore()
useThemeStore()

const { $eventBus } = useNuxtApp()
const { promptQueue, notificationShown, notificationConfig } = $eventBus
</script>

<style lang="css">
.page-enter-active,
.page-leave-active {
  transition: all 0.4s;
}
.page-enter-from,
.page-leave-to {
  opacity: 0;
  filter: blur(1rem);
}
</style>

<style lang="scss">
@use "~/assets/utils.scss";
@use "~/assets/font.scss";
@use "~/assets/overwrites.scss";
</style>
